import React, { Component } from 'react';
import { Modal, Button } from 'antd';

class ConfirmDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            working: false
        }
    }

    close = () => {
        this.setState({showModal: false, working: false});
    }

    open = () => {
        this.setState({showModal: true, working: false});
    }

    operate = () => {
        this.setState({working: true});
        this.props.operate();
        //this.close();
    }

    render() {
        const { confirmBtn, title, promptText, cancelBtn, confirmBtnType } = this.props;
        const { showModal, working } = this.state;
        const type = confirmBtnType === undefined ? "primary" : confirmBtnType;

        return (
            <Modal visible={showModal} title={title}
                   closable={ false } maskClosable={false} style={{ top: 70 }}
                   footer={[
                        <Button key="submit" type={type} size="large" onClick={this.operate} loading={working}>
                            {confirmBtn}
                        </Button>,
                        <Button key="back" size="large" onClick={this.close} disabled={this.state.working}>{cancelBtn}</Button>
                   ]}>
                {promptText}
            </Modal>
        )
    }

}

export default ConfirmDialog;


// WEBPACK FOOTER //
// ./src/commons/ConfirmDialog.js